<div class="container">
    <div style="padding: 10px; background-color: yellow; margin-bottom: 10px">
        <p>This text is part of the layout (see layouts/ExampleLayout directory) and can be used to contain HTML which needs to be shown on multiple pages. e.g. Title bar, footer, side padding, backgrounds, navigation bars, etc.</p>
    </div>
    <router-outlet></router-outlet>
</div>